// import React from "react";
// import {
//   MapPin,
//   Phone,
//   Mail,
//   Clock
// } from "lucide-react";
// import logo from '../assets/images/Logo.png'; 
// import { Link } from "react-router-dom";

// const FooterColumn = ({ title, links }) => (
//   <div>
//     <h4 className="text-white text-sm font-medium mb-4">
//       {title}
//     </h4>

//     <ul className="space-y-2 text-sm">
//       {links.map((item, i) => (
//         <li
//           key={i}
//           className="text-gray-400 hover:text-white cursor-pointer transition"
//         >
//           {item}
//         </li>
//       ))}
//     </ul>
//   </div>
// );


// const Footer = () => {
//   return (
//     <footer className="bg-gradient-to-b from-[#111111] to-[#0B0B0B] text-gray-300">
//       <div className="container mx-auto px-6 py-8">

//         {/* ================= TOP GRID ================= */}
//         <div className="grid gap-10
//                         grid-cols-1
//                         sm:grid-cols-2
//                         lg:grid-cols-5">

//           {/* ========= BRAND / INFO ========= */}
//           <div className="space-y-5 lg:col-span-1">

//             {/* LOGO */}
//         <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer">
//           <Link to="/">
//             <img src={logo} alt="Logo" className="h-8 md:h-12 object-contain" />
//           </Link>
//         </div>
//             <ul className="space-y-3 text-sm">
//               <li className="flex items-start gap-2">
//                 <MapPin size={14} className="mt-1" />
//                 <span>
//                   RTEX Retail Clothing Store <br />
//                   main market road, Pattukkottai <br />
//                   Tamil Nadu - 600040
//                 </span>
//               </li>

//               <li className="flex items-center gap-2">
//                 <Phone size={14} />
//                 +91 70100 87910
//               </li>

//               <li className="flex items-center gap-2">
//                 <Mail size={14} />
//                 chrish.christober22@gmail.com
//               </li>

//               <li className="flex items-center gap-2">
//                 <Clock size={14} />
//                 9am to 9pm
//               </li>
//             </ul>
//           </div>

//           {/* ========= HOME ========= */}
//           <FooterColumn
//             title="Home"
//             links={["Features", "Popular Products", "Contact Us", "FAQ"]}
//           />

//           {/* ========= MENSWEAR ========= */}
//           <FooterColumn
//             title="Menswear"
//             links={["Casual", "Formal", "Party", "Business"]}
//           />

//           {/* ========= WOMENSWEAR ========= */}
//           <FooterColumn
//             title="Womenswear"
//             links={["Casual", "Formal", "Party", "Business"]}
//           />

//           {/* ========= KIDSWEAR ========= */}
//           <FooterColumn
//             title="Kidswear"
//             links={["Casual", "Formal", "Party"]}
//           />
//         </div>

//         {/* ================= DIVIDER ================= */}
//         <div className="border-t border-white/10 mt-12 pt-6">

//           {/* POLICIES */}
//           <div className="flex flex-wrap justify-center gap-6 text-xs text-gray-400 mb-3">
//             <span className="hover:text-white cursor-pointer">Privacy Policy</span>
//             <span className="hover:text-white cursor-pointer">Terms of Service</span>
//             <span className="hover:text-white cursor-pointer">Shipping Policy</span>
//             <span className="hover:text-white cursor-pointer">Return & Refund Policy</span>
//           </div>

//           {/* COPYRIGHT */}
//           <p className="text-center text-xs text-gray-500">
//             © 2023 All Rights Reserved
//           </p>
//         </div>

//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React, { useEffect, useState } from "react";
import axios from "axios";
import SummaryApi from "../common/SummaryApi";
import { MapPin, Phone, Mail, Clock3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from '../assets/images/Logo.png'; 
import { Link } from "react-router-dom";
import { FaRegCopyright } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { PiInstagramLogoFill } from "react-icons/pi";
import { FaFacebook  } from "react-icons/fa6";

const FooterColumn = ({ title, links }) => {
  const navigate = useNavigate();

  return (
    <div>
      <h4 className="text-white text-sm md:text-base font-medium mb-4">
        {title}
      </h4>

      <ul className="space-y-2 text-sm md:text-base">
        {links.map((item, i) => (
          <li
            key={i}
            onClick={() => navigate(item.path)}
            className="text-[#999999] hover:text-white cursor-pointer transition whitespace-nowrap"
          >
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios({
          url: SummaryApi.getCategoryTree.url,
          method: SummaryApi.getCategoryTree.method,
        });

        if (res.data.success) {
          setCategories(res.data.categories || []);
        }
      } catch (err) {
        console.error("Footer category fetch failed", err);
      }
    };

    fetchCategories();
  }, []);

  return (
    <footer className="bg-[#191919]">
      <div className="max-w-[1600px] mx-auto px-6 pt-12 pb-8">


        {/* ================= TOP GRID ================= */}
        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-[1.5fr_1fr_1fr_1fr_1fr]
            gap-y-12
            gap-x-20
          "
        >

          {/* ========== STORE INFO ========= */}
          <div className="space-y-6">
               {/* LOGO */}
           <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer">
             <Link to="/">
               <img src={logo} alt="Logo" className="h-10 md:h-12" />
             </Link>
           </div>
            <ul className="space-y-3 text-sm md:text-base text-[#FFFFFF]">
              <li className="flex gap-2 items-start">
                <MapPin size={18} className="mt-1"/>
                <span>
                  RTEX Retail Clothing Store <br />
                  Main market road, Pattukkottai <br />
                  Tamil Nadu - 614601
                </span>
              </li>
              <li className="flex gap-2 items-center">
                <Phone size={18} /> <a href="tel:+917010087910" className="hover:text-white transition-colors">+91 70100 87910</a> 
              </li>
              <li className="flex gap-2 items-center">
                <Mail size={18} /> <a href="mailto:rtexiles1985@gmail.com" className="hover:text-white transition-colors">rtexiles1985@gmail.com</a>
              </li>
              <li className="flex gap-2 items-center">
                <Clock3 size={18} /> 9am to 9pm
              </li>
            </ul>
            {/* SOCIAL ICONS */}
          <div className="flex items-center gap-3 pt-2">
            <a
              href="https://www.facebook.com/share/1JiVoag6mA/"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full text-white flex items-center justify-center transition"
            >
              <FaFacebook size={22} />
            </a>

            <a
              href="https://www.instagram.com/r_tex_pattukkottai"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full text-white flex items-center justify-center transition"
            >
              <PiInstagramLogoFill  size={24} />
            </a>

            <a
              href="https://www.youtube.com/@rtextiles-i4r"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full text-white flex items-center justify-center transition"
            >
              <IoLogoYoutube size={24} />
            </a>
          </div>

          </div>

          <div className="mt-2">
            <FooterColumn
              title="Home"
              links={[
                { label: "Features", path: "/all-userproducts?newArrivals=1" },
                { label: "Popular Products", path: "/all-userproducts?bestSeller=1" },
                { label: "Contact Us", path: "/contact-us" },
                // { label: "FAQ", path: "/faq" },
              ]}
            />
          </div>


          {/* ========== DYNAMIC CATEGORY COLUMNS ========= */}
          {categories.slice(0, 3).map((cat) => (
            <div key={cat._id}>
              <h4 className="text-white text-sm md:text-base font-medium mb-4">
                {cat.name}
              </h4>

              <ul className="space-y-2 text-sm md:text-base  text-[#999999]">
                {cat.subCategories.map((sub) => (
                  <li
                    key={sub._id}
                    onClick={() =>
                      // navigate(
                      //   `/all-userproducts?category=${cat.slug}&subCategory=${sub.slug}`
                      // )
                      navigate(
                        `/all-userproducts?category=${sub.slug}`
                      )
                    }
                    className="text-[#999999] hover:text-white cursor-pointer transition"
                  >
                    {sub.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ================= BOTTOM ================= */}
      <div className="mt-6 md:mt-0 pt-6">
        <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-[#737373] mb-3">
          
          <Link 
            to="/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Privacy Policy
          </Link>
          
          <Link 
            to="/terms-and-conditions" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Terms & Conditions
          </Link>
          
          <Link 
            to="/shipping-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Shipping Policy
          </Link>
          
          <Link 
            to="/return-refund-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Return & Refund Policy
          </Link>

          <Link 
            to="/exchange-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Exchange Policy
          </Link>

          <Link 
            to="/safe-purchase" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Safe Purchase
          </Link>

        </div>
      </div> 
      <div className="flex justify-center px-4">
        <p className="
          text-center
          text-xs md:text-sm
          text-[#737373]
          flex flex-wrap
          justify-center
          items-center
          gap-x-2 gap-y-1
        ">
          <span className="flex items-center gap-1">
            <FaRegCopyright className="mb-[1px]" />
            {currentYear} Regees Tex
          </span>

          <span className="inline-block w-1 h-1 bg-[#737373] rounded-full" />

          <span>All Rights Reserved</span>

          <span className="inline-block w-1 h-1 bg-[#737373] rounded-full" />

          <span>
            Developed by{" "}
            <a
              href="https://www.digida.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Digida.
            </a>
          </span>
        </p>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
